<template>
  <div class="container">
    <div class="images-wrapper">
      <span
        class="image-item-wrapper"
        v-for="image in currentImages"
        :key="image.dish_img_uuid"
      >
        <image-item @delete="handleDelete"
                    :dish_img_uuid="image.dish_img_uuid"
                    :image="image"
                    :checkMode="checkMode"
                    :selfCheck="selfCheck"
        >
        </image-item>
      </span>
    </div>
    <!-- </lazy-render> -->
    <!--<div class="pagination">-->
      <!--<el-pagination-->
        <!--background-->
        <!--layout="prev pager, next"-->
        <!--@current-change="handlePagination"-->
        <!--:page-count="maxSize"-->
        <!--:current-page.sync="currentPage"-->
      <!--&gt;-->
      <!--</el-pagination>-->
    <!--</div>-->
  </div>
</template>
<script>
import imageItem from '_c/../views/trainModel/imageItemForDetected';
import {mapMutations} from 'vuex';
// import {errorMessage, successMessage} from '@/lib/msg';

export default {
  name: 'imageMarkWrapperforselfcheck',
  components: {
    imageItem
  },
  props: {
    images: {
      tyep: Array,
      default () {
        return [];
      }
    },
    selfCheck: false,
    checkMode: {
      type: Boolean,
      default: true
    },
    current_class_id: ''
  },
  data () {
    return {
      pageSize: 500,
      currentPage: 1
    };
  },
  mounted () {
    this.$emit('pageChange', this.currentPage, this.currentPage === this.maxSize);
  },
  methods: {
    ...mapMutations([
      'mark',
      'unMark',
      'delete'
    ]),

    handleDelete (dish_img_uuid) {
      this.$emit('delete', dish_img_uuid);
    },
    handlePagination (index) {
      this.currentPage = index;
      this.$emit('pageChange', index, index === this.maxSize);
    },
    handleMark (dish_img_uuid) {
      this.mark({dish_img_uuid, class_id: this.current_class_id});
    },
    handleUnmark ({dish_img_uuid, class_id}) {
      if (this.current_class_id === class_id) {
        this.unMark({dish_img_uuid, class_id});
      } else {
        this.$confirm('本图片被其它例图标记, 是否继续删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unMark({dish_img_uuid, class_id});
        }
        ).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    }
  },
  computed: {
    maxSize () {
      return Math.ceil(this.images.length / this.pageSize);
    },
    // checkMode () {
    //   return this.delete;
    // },
    currentImages () {
      return this.images.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    }
  },
  watch: {
    current_class_id () {
      this.$nextTick(() => {
        this.currentPage = 1;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
  .container {
    position: relative;
    margin: 10px;
    .images-wrapper {
      display: inline-block;
      width: 100%;
      min-height: 40vh;
      .image-item-wrapper {
        display: inline-block;
      }
    }
    .pagination {
      margin: 10px 0;
      width: 100%;
      text-align: center;
    }
  }
</style>
